export const statuses = {
	active: 'Активный',
	closed: 'Закрыт',
	suspended: 'Приостановлен',
	contract: 'Контракт отправлен',
};

export const secondary = {
	uniChoice: 'Выбор ВУЗа',
	admission: 'Поступление',
	paperwork: 'Сбор документов',
	audit: 'Проверка',
	loading: 'Загрузка',
	immi: 'Immi',
	eval: 'Эвалюация',
	profile: 'Создание профиля',
	expect: 'Ждем отбор',
	decline: 'Отказ',
	accept: 'Одобрено',
};

export const channels = {
	google: 'Поиск Google',
	ya: 'Поиск Yandex',
	forum: 'Форум',
	ig: 'Instagram',
	fb: 'Facebook',
	vk: 'Вконтакте',
	socnet: 'Социальная сеть',
	referral: 'Рекомендация',
};

export const columns = {
	firstName: {
		name: 'first_name',
		display: 'Имя',
	},
	lastName: {
		name: 'last_name',
		display: 'Фамилия',
	},
	service: {
		name: 'service',
		display: 'Услуга',
	},
	num: {
		name: 'id',
		display: '№',
	},
	status: {
		name: 'status',
		display: '*',
	},
	stage: {
		name: 'secondary_status',
		display: 'Этап',
	},
	term: {
		name: 'term',
		display: 'Период работы',
	},
	uploaded: {
		name: 'uploaded',
		display: '#',
	},
	sort: {
		name: 'sort',
		display: '@',
	},
};
